import { memo } from 'react';

import CardForm from 'components/CardForm';
import { useFormikContext } from 'formik';
import { Column, Row, SelectField, Typography } from 'shared/Houston';

import offerTitleOptions from './options';
import { DescriptionField } from './styles';

const OfferTitle = () => {
  const formContext = useFormikContext<{ title: string; description?: string }>();

  return (
    <CardForm title='Chamada da oferta Order Bump' subtitle='Selecione uma chamada para sua oferta order bump'>
      <Row>
        <Column xs={12} md={6}>
          <SelectField
            name='title'
            options={offerTitleOptions}
            value={formContext.values.title}
            onChange={(_, event) => formContext.handleChange(event)}
            errorMessage={formContext.errors.title}
          />
        </Column>
      </Row>
      <Row>
        <Column xs={12} md={6}>
          <Typography size='xxs'>Digite a descrição do Order Bump (opcional)</Typography>
          <DescriptionField
            name='description'
            placeholder='Descrição do Order Bump'
            value={formContext.values?.description}
            onChange={(value: string) => formContext.setFieldValue('description', value)}
            maxLength={255}
          />
        </Column>
      </Row>
    </CardForm>
  );
};

export default memo(OfferTitle);
